// extracted by mini-css-extract-plugin
export default {"popover":"CustomMenu_popover__NA4cw","popoverAbove":"CustomMenu_popoverAbove__mHomQ"};